/**
 * @deprecated
 *
 * ⛔️ ВНИМАНИЕ: компонент `DateInput` устарел и **НЕ РЕКОМЕНДУЕТСЯ** к использованию в новых частях проекта!
 *
 * Причины устаревания:
 * - Нарушает принципы FSD: импортирует типы и зависимости из entities
 * - Имеет сложную, неочевидную сигнатуру пропсов (множественные callback'и, неявный нейминг)
 * - Неудобен для расширения, кастомизации и поддержки
 * - Привязан к устаревшим практикам передачи значений и ошибок
 *
 * ❗️В новых модулях используйте современный компонент: `UiDateInput` (shared/ui/UiDateInput)
 *
 * Компонент оставлен только для обратной совместимости и поддержки legacy-кода.
 * При появлении необходимости доработок — рефакторьте использование на новый UiDateInput.
 */

import React from 'react';

import cn from 'classnames';
import classNames from 'classnames';
import moment, { Moment } from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';

import { FieldErrors } from 'entities/modal/model/types/modalFieldErrors';
import { formatDate } from 'shared/helpers';
import { dateLocale } from 'shared/model/dateLocale';
import 'bootstrap-daterangepicker/daterangepicker.css';
import { Icon } from 'shared/ui';

import cls from './DateInput.module.css';

interface DateInputProps {
    inputValue: string;
    parameterName: string;
    callback?: (date?: string) => void;
    options: any;
    title?: string;
    isRequired?: boolean;
    newCallback?: (date: string) => void;
    isDisabled?: boolean;
    newCallbackNotSingle?: (dates: { start: string; end: string }) => void;
    placeholder?: string;
    newCallbackNotSingleCancel?: () => void;
    classes?: string;
    error: FieldErrors['date'];
    onDateChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    setInputValue: React.Dispatch<React.SetStateAction<string>>;
    inputClassName?: string;
    calendarIconFill?: string;
}

interface DateRangePickerProps {
    startDate: Moment | string;
    endDate: Moment | string;
    element: {
        val: (value?: string) => void;
    };
}

export const DateInput = ({
    inputValue,
    parameterName,
    callback = null,
    options,
    title = null,
    isRequired = false,
    newCallback = null,
    isDisabled = false,
    newCallbackNotSingle = null,
    placeholder = null,
    newCallbackNotSingleCancel = null,
    classes,
    error,
    onDateChange,
    setInputValue,
    inputClassName = '',
    calendarIconFill = '#818998',
}: DateInputProps) => {
    // const [inputValue, setInputValue] = useState(inputValue);
    // const dispatch = useAppDispatch();

    // useEffect(() => {
    //     setInputValue(date);
    // }, [date]);

    // useEffect(() => {
    //     // const isDateValid = isValidDate(inputValue);
    //     if (modalMode && modalMode === 'editTask') {
    //         // dispatch(changeEditModalEndDate(isDateValid ? inputValue : ''));
    //         dispatch(changeEditModalEndDate(inputValue));
    //     }
    //     if (modalMode && modalMode === 'addNewTask') {
    //         // dispatch(changeModalDate(isDateValid ? inputValue : ''));
    //         dispatch(changeModalDate(inputValue));
    //     }
    // }, [inputValue]);

    const initialSettings = {
        ...options,
        locale: dateLocale,
        minDate: moment('2020-01-01', 'YYYY-MM-DD'),
        maxDate: moment(moment().add(2, 'years').endOf('year').format('YYYY-MM-DD'), 'YYYY-MM-DD'),
    };

    const inputProps = {
        defaultValue: options.options || '',
    };

    const handleCancel = (event: React.SyntheticEvent | unknown, picker: DateRangePickerProps) => {
        if (inputValue === '') {
            return;
        }
        picker.element.val('');
        if (callback) {
            callback('');
        }
        if (newCallbackNotSingleCancel) {
            newCallbackNotSingleCancel();
        }
    };

    const handleApply = (event: React.SyntheticEvent | unknown, picker: DateRangePickerProps) => {
        // console.log('Apply handle!');
        // const formattedDate = picker.startDate.format('DD.MM.YYYY');
        // const formattedDate = formatDate(picker.startDate, 'YYYY-MM-DD');
        const formattedDate = formatDate(picker.startDate, 'DD.MM.YYYY');
        // console.log('formattedDate in DateInput at handle apply: ', formattedDate);
        picker.element.val(formattedDate);
        setInputValue(formattedDate);

        if (callback) {
            console.log('callback');
            console.log(picker);
            callback(formatDate(picker.startDate, 'DD.MM.YYYY'));
        }
        if (newCallback) {
            // console.log('newCallback');
            newCallback(formatDate(picker.startDate, 'DD.MM.YYYY'));
        }
        if (newCallbackNotSingle) {
            picker.element.val(
                `${formatDate(picker.startDate, 'DD.MM.YYYY')} - ${formatDate(
                    picker.endDate,
                    'DD.MM.YYYY'
                )}`
            );
            newCallbackNotSingle({
                start: formatDate(picker.startDate, 'DD.MM.YYYY'),
                end: formatDate(picker.endDate, 'DD.MM.YYYY'),
            });
        }
    };

    // const handleChangeDate = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     if (error.isError) {
    //         setFieldErrors((prev) => ({
    //             ...prev,
    //             date: { isError: false, errorMessage: null },
    //         }));
    //     }
    //     // const isDateValid = isValidDate(e.target.value);
    //     setInputValue(e.target.value);
    //     // передавать как cb
    //     // dispatch(changeModalDate(isDateValid ? e.target.value : ''));
    //
    //     const parsedDate = moment(e.target.value, 'DD.MM.YYYY', true);
    //     console.log(parsedDate);
    //     if (modalMode && modalMode === 'editTask') {
    //         console.log('мы в modalmode === editTask', 'modalmode: ', modalMode);
    //         // dispatch(changeEditModalEndDate(isDateValid ? inputValue : ''));
    //         dispatch(changeEditModalEndDate(inputValue));
    //     }
    //     if (modalMode && modalMode === 'addNewTask') {
    //         console.log('мы в modalmode === addNewTask', 'modalmode: ', modalMode);
    //         // dispatch(changeModalDate(isDateValid ? inputValue : ''));
    //         dispatch(changeModalDate(inputValue));
    //     }
    //     // dispatch(changeModalDate(e.target.value));
    // };

    return (
        <div className={classNames(cls.wrapperInput, [classes], { [cls.disabled]: isDisabled })}>
            {title && (
                <label className={classNames(cls.modalLabelSelect)}>
                    {title}
                    {isRequired && <span>*</span>}
                </label>
            )}
            <div className={classNames(cls.calendar, { [cls.disabled]: isDisabled })}>
                <DateRangePicker
                    initialSettings={{ ...initialSettings }}
                    onApply={handleApply}
                    onCancel={handleCancel}
                    {...(inputProps as any)}
                >
                    <input
                        value={inputValue || ''}
                        onChange={onDateChange}
                        placeholder={placeholder || ''}
                        disabled={isDisabled}
                        data-id={parameterName}
                        className={cn(cls.input, cls.calendarInput, inputClassName)}
                        type="text"
                    />
                </DateRangePicker>
                <div
                    className={classNames(cls.calendarIconWrapper, { [cls.disabled]: isDisabled })}
                >
                    <Icon iconName="taskCalendar" fill={calendarIconFill} />
                </div>
                {/* <div className={classNames(s.calendarIcon, { [s.disabled]: isDisabled })} /> */}
            </div>
            {error.isError && <span className={cls.errorMessage}>{error.errorMessage}</span>}
        </div>
    );
};
